// Module
var code = "<react-component name=\"ReportsList\"></react-component>\n";
// Exports
module.exports = code;